import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import ProductSelect from '~/app/corporate/core/containers/ProductSelect';


const InlineProductSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={ProductSelect}
      useNative={false}
      mode='multiple'
      showSearch={true}
      placeholder='Select product...'
      {...other}
    />
  );
};

InlineProductSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineProductSelect.defaultProps = {
  label: 'Product',
  description: 'Product to be included'
};

export default memo(InlineProductSelect);
